import { muiTheme } from '@/theme/muiTheme'
import { TFunction } from 'i18next'

interface StrengthMap {
  [key: number]: {
    label: string
    color?: 'inherit' | 'error' | 'primary' | 'secondary' | 'info' | 'success' | 'warning'
    resultColor: string
  }
}

export const getStrengthMap = (t: TFunction): StrengthMap => ({
  0: {
    label: t('common:passwordStrength.veryWeak'),
    color: 'error',
    resultColor: muiTheme.palette.error.dark,
  },
  1: {
    label: t('common:passwordStrength.weak'),
    color: 'error',
    resultColor: muiTheme.palette.error.dark,
  },
  2: {
    label: t('common:passwordStrength.fair'),
    color: 'info',
    resultColor: muiTheme.palette.info.dark,
  },
  3: {
    label: t('common:passwordStrength.strong'),
    color: 'success',
    resultColor: muiTheme.palette.primary.dark,
  },
  4: {
    label: t('common:passwordStrength.veryStrong'),
    color: 'success',
    resultColor: muiTheme.palette.primary.dark,
  },
})
